import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";
import {effacerPicto} from "../../Theme/picto";

export interface EffacerPictoProps extends pictoProps {
}

export interface EffacerPictoState extends pictoState {
}

export class EffacerPicto extends Picto<EffacerPictoProps,EffacerPictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.effacerPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(EffacerPicto);
